const results = {
 "academicodec_hifi_16k_320d": {
  "bps": 2,
  "tps": 50,
  "speech_mel": 2.187,
  "speech_pesq": 2.292,
  "speech_stoi": 0.875,
  "speech_f0corr": 0.87,
  "overall_mel": 2.212,
  "overall_pesq": 1.99,
  "overall_stoi": 0.676,
  "overall_f0corr": 0.658,
  "audio_mel": 2.335,
  "audio_pesq": 1.518,
  "audio_stoi": 0.537,
  "audio_f0corr": 0.332,
  "music_mel": 2.114,
  "music_pesq": 2.161,
  "music_stoi": 0.618,
  "music_f0corr": 0.772
 },
 "academicodec_hifi_16k_320d_large_uni": {
  "bps": 2,
  "tps": 50,
  "speech_mel": 2.128,
  "speech_pesq": 2.313,
  "speech_stoi": 0.87,
  "speech_f0corr": 0.887,
  "overall_mel": 2.14,
  "overall_pesq": 2.093,
  "overall_stoi": 0.691,
  "overall_f0corr": 0.71,
  "audio_mel": 2.301,
  "audio_pesq": 1.635,
  "audio_stoi": 0.564,
  "audio_f0corr": 0.399,
  "music_mel": 1.992,
  "music_pesq": 2.331,
  "music_stoi": 0.639,
  "music_f0corr": 0.844
 },
 "academicodec_hifi_24k_320d": {
  "bps": 3,
  "tps": 75,
  "speech_mel": 2.215,
  "speech_pesq": 2.263,
  "speech_stoi": 0.887,
  "speech_f0corr": 0.868,
  "overall_mel": 2.008,
  "overall_pesq": 1.95,
  "overall_stoi": 0.7,
  "overall_f0corr": 0.66,
  "audio_mel": 1.784,
  "audio_pesq": 1.562,
  "audio_stoi": 0.583,
  "audio_f0corr": 0.343,
  "music_mel": 2.025,
  "music_pesq": 2.024,
  "music_stoi": 0.63,
  "music_f0corr": 0.77
 },
 "audiodec_24k_320d": {
  "bps": 6,
  "tps": 75,
  "speech_mel": 0.947,
  "speech_pesq": 1.759,
  "speech_stoi": 0.757,
  "speech_f0corr": 0.791,
  "overall_mel": 1.241,
  "overall_pesq": 1.618,
  "overall_stoi": 0.561,
  "overall_f0corr": 0.591,
  "audio_mel": 1.42,
  "audio_pesq": 1.508,
  "audio_stoi": 0.391,
  "audio_f0corr": 0.286,
  "music_mel": 1.356,
  "music_pesq": 1.586,
  "music_stoi": 0.533,
  "music_f0corr": 0.697
 },
 "auv": {
  "bps": 0.5,
  "tps": 50,
  "speech_mel": 0.749,
  "speech_pesq": 2.098,
  "speech_stoi": 0.85,
  "speech_f0corr": 0.852,
  "overall_mel": 1.255,
  "overall_pesq": 1.955,
  "overall_stoi": 0.66,
  "overall_f0corr": 0.65,
  "audio_mel": 1.882,
  "audio_pesq": 1.568,
  "audio_stoi": 0.521,
  "audio_f0corr": 0.314,
  "music_mel": 1.134,
  "music_pesq": 2.198,
  "music_stoi": 0.611,
  "music_f0corr": 0.785
 },
 "bigcodec_1k": {
  "bps": 1,
  "tps": 80,
  "speech_mel": 0.802,
  "speech_pesq": 2.209,
  "speech_stoi": 0.877,
  "speech_f0corr": 0.867,
  "overall_mel": 1.477,
  "overall_pesq": 1.842,
  "overall_stoi": 0.66,
  "overall_f0corr": 0.634,
  "audio_mel": 2.118,
  "audio_pesq": 1.39,
  "audio_stoi": 0.498,
  "audio_f0corr": 0.306,
  "music_mel": 1.51,
  "music_pesq": 1.927,
  "music_stoi": 0.606,
  "music_f0corr": 0.729
 },
 "dac_16k": {
  "bps": 6,
  "tps": 50,
  "speech_mel": 0.513,
  "speech_pesq": 3.881,
  "speech_stoi": 0.961,
  "speech_f0corr": 0.94,
  "overall_mel": 0.596,
  "overall_pesq": 3.634,
  "overall_stoi": 0.873,
  "overall_f0corr": 0.79,
  "audio_mel": 0.534,
  "audio_pesq": 3.448,
  "audio_stoi": 0.858,
  "audio_f0corr": 0.526,
  "music_mel": 0.741,
  "music_pesq": 3.573,
  "music_stoi": 0.799,
  "music_f0corr": 0.904
 },
 "dac_24k": {
  "bps": 24,
  "tps": 75,
  "speech_mel": 0.349,
  "speech_pesq": 4.351,
  "speech_stoi": 0.986,
  "speech_f0corr": 0.973,
  "overall_mel": 0.379,
  "overall_pesq": 4.252,
  "overall_stoi": 0.945,
  "overall_f0corr": 0.842,
  "audio_mel": 0.292,
  "audio_pesq": 4.198,
  "audio_stoi": 0.964,
  "audio_f0corr": 0.612,
  "music_mel": 0.496,
  "music_pesq": 4.207,
  "music_stoi": 0.885,
  "music_f0corr": 0.94
 },
 "dac_44k": {
  "bps": 8,
  "tps": 86,
  "speech_mel": 0.769,
  "speech_pesq": 2.382,
  "speech_stoi": 0.89,
  "speech_f0corr": 0.9,
  "overall_mel": 0.764,
  "overall_pesq": 2.882,
  "overall_stoi": 0.825,
  "overall_f0corr": 0.763,
  "audio_mel": 0.625,
  "audio_pesq": 3.168,
  "audio_stoi": 0.824,
  "audio_f0corr": 0.514,
  "music_mel": 0.899,
  "music_pesq": 3.096,
  "music_stoi": 0.76,
  "music_f0corr": 0.876
 },
 "encodec_24k_12bps": {
  "bps": 12,
  "tps": 75,
  "speech_mel": 0.884,
  "speech_pesq": 3.304,
  "speech_stoi": 0.943,
  "speech_f0corr": 0.938,
  "overall_mel": 1.154,
  "overall_pesq": 3.012,
  "overall_stoi": 0.835,
  "overall_f0corr": 0.772,
  "audio_mel": 1.273,
  "audio_pesq": 2.921,
  "audio_stoi": 0.809,
  "audio_f0corr": 0.484,
  "music_mel": 1.304,
  "music_pesq": 2.811,
  "music_stoi": 0.754,
  "music_f0corr": 0.892
 },
 "encodec_24k_1_5bps": {
  "bps": 1.5,
  "tps": 75,
  "speech_mel": 1.268,
  "speech_pesq": 1.516,
  "speech_stoi": 0.799,
  "speech_f0corr": 0.748,
  "overall_mel": 1.476,
  "overall_pesq": 1.536,
  "overall_stoi": 0.639,
  "overall_f0corr": 0.638,
  "audio_mel": 1.519,
  "audio_pesq": 1.517,
  "audio_stoi": 0.557,
  "audio_f0corr": 0.366,
  "music_mel": 1.64,
  "music_pesq": 1.575,
  "music_stoi": 0.561,
  "music_f0corr": 0.8
 },
 "encodec_24k_24bps": {
  "bps": 24,
  "tps": 75,
  "speech_mel": 0.823,
  "speech_pesq": 3.658,
  "speech_stoi": 0.96,
  "speech_f0corr": 0.944,
  "overall_mel": 1.095,
  "overall_pesq": 3.362,
  "overall_stoi": 0.865,
  "overall_f0corr": 0.782,
  "audio_mel": 1.217,
  "audio_pesq": 3.325,
  "audio_stoi": 0.855,
  "audio_f0corr": 0.5,
  "music_mel": 1.246,
  "music_pesq": 3.103,
  "music_stoi": 0.781,
  "music_f0corr": 0.902
 },
 "encodec_24k_3bps": {
  "bps": 3,
  "tps": 75,
  "speech_mel": 1.113,
  "speech_pesq": 1.984,
  "speech_stoi": 0.861,
  "speech_f0corr": 0.845,
  "overall_mel": 1.344,
  "overall_pesq": 1.907,
  "overall_stoi": 0.714,
  "overall_f0corr": 0.694,
  "audio_mel": 1.429,
  "audio_pesq": 1.813,
  "audio_stoi": 0.643,
  "audio_f0corr": 0.398,
  "music_mel": 1.488,
  "music_pesq": 1.924,
  "music_stoi": 0.639,
  "music_f0corr": 0.84
 },
 "encodec_24k_6bps": {
  "bps": 6,
  "tps": 75,
  "speech_mel": 1.001,
  "speech_pesq": 2.635,
  "speech_stoi": 0.91,
  "speech_f0corr": 0.901,
  "overall_mel": 1.247,
  "overall_pesq": 2.426,
  "overall_stoi": 0.782,
  "overall_f0corr": 0.74,
  "audio_mel": 1.35,
  "audio_pesq": 2.297,
  "audio_stoi": 0.731,
  "audio_f0corr": 0.448,
  "music_mel": 1.391,
  "music_pesq": 2.348,
  "music_stoi": 0.704,
  "music_f0corr": 0.871
 },
 "funcodec_en_libritts_16k_gr1nq32ds320": {
  "bps": 16,
  "tps": 50,
  "speech_mel": 0.817,
  "speech_pesq": 3.479,
  "speech_stoi": 0.836,
  "speech_f0corr": 0.915,
  "overall_mel": 0.933,
  "overall_pesq": 3.037,
  "overall_stoi": 0.762,
  "overall_f0corr": 0.733,
  "audio_mel": 0.809,
  "audio_pesq": 2.774,
  "audio_stoi": 0.741,
  "audio_f0corr": 0.441,
  "music_mel": 1.173,
  "music_pesq": 2.859,
  "music_stoi": 0.708,
  "music_f0corr": 0.841
 },
 "funcodec_en_libritts_16k_gr8nq32ds320": {
  "bps": 16,
  "tps": 50,
  "speech_mel": 0.799,
  "speech_pesq": 3.17,
  "speech_stoi": 0.837,
  "speech_f0corr": 0.885,
  "overall_mel": 0.901,
  "overall_pesq": 2.723,
  "overall_stoi": 0.747,
  "overall_f0corr": 0.7,
  "audio_mel": 0.832,
  "audio_pesq": 2.228,
  "audio_stoi": 0.698,
  "audio_f0corr": 0.397,
  "music_mel": 1.073,
  "music_pesq": 2.771,
  "music_stoi": 0.707,
  "music_f0corr": 0.817
 },
 "funcodec_en_libritts_16k_nq32ds320": {
  "bps": 16,
  "tps": 50,
  "speech_mel": 0.743,
  "speech_pesq": 2.879,
  "speech_stoi": 0.934,
  "speech_f0corr": 0.897,
  "overall_mel": 1.028,
  "overall_pesq": 2.408,
  "overall_stoi": 0.787,
  "overall_f0corr": 0.697,
  "audio_mel": 0.96,
  "audio_pesq": 2.007,
  "audio_stoi": 0.708,
  "audio_f0corr": 0.395,
  "music_mel": 1.38,
  "music_pesq": 2.339,
  "music_stoi": 0.719,
  "music_f0corr": 0.798
 },
 "funcodec_en_libritts_16k_nq32ds640": {
  "bps": 8,
  "tps": 25,
  "speech_mel": 0.799,
  "speech_pesq": 2.618,
  "speech_stoi": 0.915,
  "speech_f0corr": 0.874,
  "overall_mel": 1.125,
  "overall_pesq": 2.12,
  "overall_stoi": 0.73,
  "overall_f0corr": 0.64,
  "audio_mel": 1.101,
  "audio_pesq": 1.551,
  "audio_stoi": 0.6,
  "audio_f0corr": 0.311,
  "music_mel": 1.474,
  "music_pesq": 2.191,
  "music_stoi": 0.676,
  "music_f0corr": 0.735
 },
 "funcodec_zh_en_16k_nq32ds320": {
  "bps": 16,
  "tps": 50,
  "speech_mel": 0.697,
  "speech_pesq": 3.171,
  "speech_stoi": 0.946,
  "speech_f0corr": 0.908,
  "overall_mel": 1.153,
  "overall_pesq": 2.598,
  "overall_stoi": 0.803,
  "overall_f0corr": 0.711,
  "audio_mel": 1.103,
  "audio_pesq": 2.106,
  "audio_stoi": 0.73,
  "audio_f0corr": 0.408,
  "music_mel": 1.659,
  "music_pesq": 2.519,
  "music_stoi": 0.733,
  "music_f0corr": 0.816
 },
 "funcodec_zh_en_16k_nq32ds640": {
  "bps": 8,
  "tps": 25,
  "speech_mel": 0.688,
  "speech_pesq": 3.022,
  "speech_stoi": 0.939,
  "speech_f0corr": 0.911,
  "overall_mel": 1.017,
  "overall_pesq": 2.45,
  "overall_stoi": 0.79,
  "overall_f0corr": 0.722,
  "audio_mel": 0.939,
  "audio_pesq": 2.038,
  "audio_stoi": 0.715,
  "audio_f0corr": 0.418,
  "music_mel": 1.424,
  "music_pesq": 2.289,
  "music_stoi": 0.715,
  "music_f0corr": 0.836
 },
 "llmcodec": {
  "bps": 0.5,
  "tps": 50,
  "speech_mel": 0.713,
  "speech_pesq": 2.11,
  "speech_stoi": 0.859,
  "speech_f0corr": 0.843,
  "overall_mel": 1.239,
  "overall_pesq": 1.951,
  "overall_stoi": 0.665,
  "overall_f0corr": 0.629,
  "audio_mel": 1.874,
  "audio_pesq": 1.558,
  "audio_stoi": 0.519,
  "audio_f0corr": 0.281,
  "music_mel": 1.131,
  "music_pesq": 2.186,
  "music_stoi": 0.616,
  "music_f0corr": 0.762
 },
 "speech_tokenizer_16k": {
  "bps": 4,
  "tps": 50,
  "speech_mel": 0.802,
  "speech_pesq": 2.132,
  "speech_stoi": 0.858,
  "speech_f0corr": 0.864,
  "overall_mel": 1.444,
  "overall_pesq": 1.761,
  "overall_stoi": 0.641,
  "overall_f0corr": 0.637,
  "audio_mel": 1.967,
  "audio_pesq": 1.455,
  "audio_stoi": 0.508,
  "audio_f0corr": 0.319,
  "music_mel": 1.564,
  "music_pesq": 1.697,
  "music_stoi": 0.559,
  "music_f0corr": 0.729
 },
 "sqcodec_16k_0k75bps": {
  "bps": 0.75,
  "tps": 50,
  "speech_mel": 3.474,
  "speech_pesq": 1.071,
  "speech_stoi": 0.382,
  "speech_f0corr": 0.535,
  "overall_mel": 3.862,
  "overall_pesq": 1.109,
  "overall_stoi": 0.282,
  "overall_f0corr": 0.407,
  "audio_mel": 4.0,
  "audio_pesq": 1.149,
  "audio_stoi": 0.221,
  "audio_f0corr": 0.237,
  "music_mel": 4.113,
  "music_pesq": 1.106,
  "music_stoi": 0.243,
  "music_f0corr": 0.448
 },
 "sqcodec_16k_12kbps": {
  "bps": 12,
  "tps": 50,
  "speech_mel": 4.084,
  "speech_pesq": 1.183,
  "speech_stoi": 0.491,
  "speech_f0corr": 0.384,
  "overall_mel": 4.371,
  "overall_pesq": 1.276,
  "overall_stoi": 0.388,
  "overall_f0corr": 0.347,
  "audio_mel": 4.5,
  "audio_pesq": 1.439,
  "audio_stoi": 0.333,
  "audio_f0corr": 0.164,
  "music_mel": 4.53,
  "music_pesq": 1.205,
  "music_stoi": 0.341,
  "music_f0corr": 0.493
 },
 "sqcodec_16k_1k5bps": {
  "bps": 1.5,
  "tps": 50,
  "speech_mel": 3.443,
  "speech_pesq": 1.088,
  "speech_stoi": 0.474,
  "speech_f0corr": 0.431,
  "overall_mel": 3.839,
  "overall_pesq": 1.123,
  "overall_stoi": 0.356,
  "overall_f0corr": 0.363,
  "audio_mel": 3.941,
  "audio_pesq": 1.188,
  "audio_stoi": 0.294,
  "audio_f0corr": 0.243,
  "music_mel": 4.134,
  "music_pesq": 1.093,
  "music_stoi": 0.301,
  "music_f0corr": 0.414
 },
 "sqcodec_16k_3kbps": {
  "bps": 3,
  "tps": 50,
  "speech_mel": 2.894,
  "speech_pesq": 1.272,
  "speech_stoi": 0.394,
  "speech_f0corr": 0.407,
  "overall_mel": 3.337,
  "overall_pesq": 1.377,
  "overall_stoi": 0.323,
  "overall_f0corr": 0.342,
  "audio_mel": 3.575,
  "audio_pesq": 1.572,
  "audio_stoi": 0.286,
  "audio_f0corr": 0.221,
  "music_mel": 3.541,
  "music_pesq": 1.288,
  "music_stoi": 0.29,
  "music_f0corr": 0.397
 },
 "sqcodec_16k_6kbps": {
  "bps": 6,
  "tps": 50,
  "speech_mel": 3.455,
  "speech_pesq": 1.287,
  "speech_stoi": 0.451,
  "speech_f0corr": 0.277,
  "overall_mel": 3.894,
  "overall_pesq": 1.366,
  "overall_stoi": 0.356,
  "overall_f0corr": 0.298,
  "audio_mel": 4.14,
  "audio_pesq": 1.57,
  "audio_stoi": 0.297,
  "audio_f0corr": 0.198,
  "music_mel": 4.087,
  "music_pesq": 1.24,
  "music_stoi": 0.321,
  "music_f0corr": 0.419
 },
 "sqcodec_24k_12kbps": {
  "bps": 12,
  "tps": 75,
  "speech_mel": 3.717,
  "speech_pesq": 1.21,
  "speech_stoi": 0.442,
  "speech_f0corr": 0.357,
  "overall_mel": 4.136,
  "overall_pesq": 1.29,
  "overall_stoi": 0.36,
  "overall_f0corr": 0.328,
  "audio_mel": 4.361,
  "audio_pesq": 1.462,
  "audio_stoi": 0.318,
  "audio_f0corr": 0.163,
  "music_mel": 4.329,
  "music_pesq": 1.197,
  "music_stoi": 0.321,
  "music_f0corr": 0.464
 },
 "sqcodec_24k_24kbps": {
  "bps": 24,
  "tps": 75,
  "speech_mel": 3.961,
  "speech_pesq": 1.048,
  "speech_stoi": 0.576,
  "speech_f0corr": 0.457,
  "overall_mel": 4.057,
  "overall_pesq": 1.065,
  "overall_stoi": 0.463,
  "overall_f0corr": 0.399,
  "audio_mel": 3.93,
  "audio_pesq": 1.097,
  "audio_stoi": 0.413,
  "audio_f0corr": 0.253,
  "music_mel": 4.28,
  "music_pesq": 1.051,
  "music_stoi": 0.4,
  "music_f0corr": 0.488
 },
 "unicodec_24k": {
  "bps": 12,
  "tps": 75,
  "speech_mel": 0.837,
  "speech_pesq": 2.025,
  "speech_stoi": 0.851,
  "speech_f0corr": 0.817,
  "overall_mel": 1.132,
  "overall_pesq": 1.812,
  "overall_stoi": 0.651,
  "overall_f0corr": 0.618,
  "audio_mel": 1.358,
  "audio_pesq": 1.55,
  "audio_stoi": 0.514,
  "audio_f0corr": 0.279,
  "music_mel": 1.201,
  "music_pesq": 1.862,
  "music_stoi": 0.588,
  "music_f0corr": 0.759
 },
 "wavtokenizer_24k_large_600_4096": {
  "bps": 0.48,
  "tps": 40,
  "speech_mel": 1.128,
  "speech_pesq": 1.547,
  "speech_stoi": 0.765,
  "speech_f0corr": 0.781,
  "overall_mel": 1.408,
  "overall_pesq": 1.456,
  "overall_stoi": 0.549,
  "overall_f0corr": 0.585,
  "audio_mel": 1.568,
  "audio_pesq": 1.337,
  "audio_stoi": 0.404,
  "audio_f0corr": 0.253,
  "music_mel": 1.527,
  "music_pesq": 1.485,
  "music_stoi": 0.478,
  "music_f0corr": 0.722
 },
 "wavtokenizer_24k_large_speech_75token": {
  "bps": 0.9,
  "tps": 75,
  "speech_mel": 0.783,
  "speech_pesq": 2.024,
  "speech_stoi": 0.848,
  "speech_f0corr": 0.828,
  "overall_mel": 1.099,
  "overall_pesq": 1.747,
  "overall_stoi": 0.636,
  "overall_f0corr": 0.574,
  "audio_mel": 1.316,
  "audio_pesq": 1.46,
  "audio_stoi": 0.489,
  "audio_f0corr": 0.225,
  "music_mel": 1.198,
  "music_pesq": 1.756,
  "music_stoi": 0.57,
  "music_f0corr": 0.669
 },
 "wavtokenizer_24k_medium_600_4096": {
  "bps": 0.9,
  "tps": 75,
  "speech_mel": 0.922,
  "speech_pesq": 1.842,
  "speech_stoi": 0.823,
  "speech_f0corr": 0.819,
  "overall_mel": 1.245,
  "overall_pesq": 1.601,
  "overall_stoi": 0.602,
  "overall_f0corr": 0.586,
  "audio_mel": 1.4,
  "audio_pesq": 1.381,
  "audio_stoi": 0.454,
  "audio_f0corr": 0.257,
  "music_mel": 1.412,
  "music_pesq": 1.579,
  "music_stoi": 0.528,
  "music_f0corr": 0.682
 },
 "wavtokenizer_24k_small_600_4096": {
  "bps": 0.48,
  "tps": 40,
  "speech_mel": 1.087,
  "speech_pesq": 1.439,
  "speech_stoi": 0.761,
  "speech_f0corr": 0.767,
  "overall_mel": 1.409,
  "overall_pesq": 1.354,
  "overall_stoi": 0.541,
  "overall_f0corr": 0.535,
  "audio_mel": 1.502,
  "audio_pesq": 1.273,
  "audio_stoi": 0.386,
  "audio_f0corr": 0.207,
  "music_mel": 1.639,
  "music_pesq": 1.349,
  "music_stoi": 0.475,
  "music_f0corr": 0.629
 }
};
export default results;